import React, { createContext, useState, useContext } from "react";

export const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [isSigninDialogOpen, setIsSigninDialogOpen] = useState(false);
  const [isSignupDialogOpen, setIsSignupDialogOpen] = useState(false);
  const [isVerifyEmailDialogOpen, setIsVerifyEmailDialogOpen] = useState(false);
  const [isForgotPasswordDialogOpen, setIsForgotPasswordDialogOpen] =
    useState(false);
  const [isTrialWelcomeDialogOpen, setIsTrialWelcomeDialogOpen] =
    useState(false);
  const [verifyEmailDialogData, setVerifyEmailDialogData] = useState({});
  const [isTrialExpiredDialogOpen, setIsTrialExpiredDialogOpen] =
    useState(false);

  const openSigninDialog = () => {
    setIsSigninDialogOpen(true);
  };

  const closeSigninDialog = () => {
    setIsSigninDialogOpen(false);
  };

  const openSignupDialog = () => {
    setIsSigninDialogOpen(false);
    setIsSignupDialogOpen(true);
  };

  const closeSignupDialog = () => {
    setIsSignupDialogOpen(false);
  };

  const openVerifyEmailDialog = (firstName, lastName, email) => {
    setVerifyEmailDialogData({ firstName, lastName, email });
    setIsSignupDialogOpen(false);
    setIsVerifyEmailDialogOpen(true);
  };

  const closeVerifyEmailDialog = () => {
    setIsVerifyEmailDialogOpen(false);
  };

  const openForgotPasswordDialog = () => {
    setIsSigninDialogOpen(false);
    setIsForgotPasswordDialogOpen(true);
  };

  const closeForgotPasswordDialog = () => {
    setIsForgotPasswordDialogOpen(false);
  };

  const openTrialWelcomeDialog = () => {
    setIsTrialWelcomeDialogOpen(true);
  };

  const closeTrialWelcomeDialog = () => {
    setIsTrialWelcomeDialogOpen(false);
  };

  const openTrialExpiredDialog = () => {
    setIsTrialExpiredDialogOpen(true);
  };

  const closeTrialExpiredDialog = () => {
    setIsTrialExpiredDialogOpen(false);
  };

  return (
    <DialogContext.Provider
      value={{
        isSigninDialogOpen,
        openSigninDialog,
        closeSigninDialog,
        isSignupDialogOpen,
        openSignupDialog,
        closeSignupDialog,
        isVerifyEmailDialogOpen,
        verifyEmailDialogData,
        openVerifyEmailDialog,
        closeVerifyEmailDialog,
        isForgotPasswordDialogOpen,
        openForgotPasswordDialog,
        closeForgotPasswordDialog,
        isTrialWelcomeDialogOpen,
        openTrialWelcomeDialog,
        closeTrialWelcomeDialog,
        isTrialExpiredDialogOpen,
        openTrialExpiredDialog,
        closeTrialExpiredDialog,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};
